import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchasePopup } from './components/PurchasePopup';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { CheckIcon, XIcon, ShieldIcon, DownloadIcon, UsersIcon, ClockIcon, StarIcon, ZapIcon, AwardIcon, ChevronDownIcon } from 'lucide-react';
const PURCHASE_URL = 'https://servicios-juridicos-2.myshopify.com/cart/51819708383463:1';
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Meta Pixel injection
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1330155108219675', {
        em: '',
        ph: ''
      });
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1330155108219675&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <PurchasePopup data-id="element-1" />
      <ExitIntentPopup data-id="element-2" />

      {/* Top Urgency Bar */}
      <div className="w-full bg-red-600 text-white py-2 px-4 text-center sticky top-0 z-40" data-id="element-3">
        <div className="max-w-7xl mx-auto" data-id="element-4">
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs md:text-sm" data-id="element-5">
            <span className="flex items-center gap-1.5" data-id="element-6">
              ⏳ <span className="font-bold" data-id="element-7">OFERTA EXPIRA EN:</span>{' '}
              <CountdownTimer data-id="element-8" />
            </span>
          </div>
          <div className="text-xs text-yellow-300 mt-0.5 text-center" data-id="element-9">
            Últimos 4 cupos al precio promocional + 6 bonus
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="w-full bg-white py-6 px-4" data-id="element-10">
        <div className="max-w-5xl mx-auto text-center" data-id="element-11">
          <p className="text-base md:text-lg text-gray-700 mb-3 font-semibold text-center" data-id="element-12">
            Para NOVELES ABOGADOS — Válido para toda la Argentina 🇦🇷
          </p>
          <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 leading-tight uppercase text-center" data-id="element-13">
            <span className="text-green-600" data-id="element-14">Ahorrá 1 año</span> de tiempo y{' '}
            <span className="text-red-600" data-id="element-15">evitá errores</span> de amateur en tu{' '}
            <span className="text-blue-600" data-id="element-16">primer año</span> como abogado
          </h1>

          <a href={PURCHASE_URL} className="block max-w-lg mx-auto mb-4" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/oYjX3VyrBdMpQpCi4aCGUc/Portada_1.png" alt="Megapack Jurídico 2026" className="w-full h-auto rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-18" />
          </a>

          <h2 className="text-xl md:text-2xl text-gray-900 mb-6 max-w-3xl mx-auto font-bold leading-tight text-center" data-id="element-19">
            TUS PRIMEROS PASOS EN LA PRÁCTICA PROFESIONAL Y PROCURACIÓN JURÍDICA
          </h2>

          <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto text-center" data-id="element-20">
            Un sistema listo para usar para que dejes de improvisar y empieces a
            ejercer con seguridad, sin perder semanas en prueba y error.
          </p>

          {/* PRIMER BOTÓN → scroll a oferta */}
          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase mb-8 text-center" data-id="element-21">
            🟩 SÍ, QUIERO ACCEDER AHORA
          </a>

          <div className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto mb-6" data-id="element-22">
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-6 uppercase text-center" data-id="element-23">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026 + 6 BONUS
            </h3>
            <div className="grid md:grid-cols-2 gap-4 text-left" data-id="element-24">
              <div className="flex items-start gap-3" data-id="element-25">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-26" />
                <span className="text-gray-800" data-id="element-27">
                  Escrito + estructura + orden (sin caos mental)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-28">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-29" />
                <span className="text-gray-800" data-id="element-30">
                  Paso a paso real (lo que en la facu no te dicen)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-31">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-32" />
                <span className="text-gray-800" data-id="element-33">
                  Subida al PJN sin trabarte (fueros principales)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-34">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-35" />
                <span className="text-gray-800" data-id="element-36">
                  Honorarios con criterio (sin regalar tu laburo)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-37">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-38" />
                <span className="text-gray-800" data-id="element-39">
                  Primera entrevista con clientes sin quedarte en blanco
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-40">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-41" />
                <span className="text-gray-800" data-id="element-42">
                  Comunidad +400 colegas para destrabarte rápido
                </span>
              </div>
            </div>
          </div>

          <p className="text-sm font-bold text-yellow-600 mb-4 text-center" data-id="element-43">
            ⭐ Garantía de satisfacción 7 días ⭐
          </p>
        </div>
      </section>

      {/* Problem Section */}
      <section className="w-full bg-gray-50 py-12 px-4" data-id="element-44">
        <div className="max-w-4xl mx-auto" data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 text-center uppercase leading-tight" data-id="element-46">
            Si sos novel abogado, dejame hacerte una pregunta honesta:
          </h2>
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8" data-id="element-47">
            <p className="text-2xl md:text-3xl font-bold text-red-600 mb-6 text-center" data-id="element-48">
              ¿Te pasa que el miedo a equivocarte te hace tardar el triple?
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-49">
              Porque una cosa es saber Derecho… y otra muy distinta es ejercer
              en el mundo real, donde:
            </p>
            <div className="space-y-4" data-id="element-50">
              <div className="flex items-start gap-3" data-id="element-51">
                <span className="text-red-500 text-xl" data-id="element-52">❌</span>
                <span className="text-gray-800" data-id="element-53">
                  Un detalle te puede hacer perder días
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-54">
                <span className="text-red-500 text-xl" data-id="element-55">❌</span>
                <span className="text-gray-800" data-id="element-56">
                  Un formato mal armado te lo rebotan
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-57">
                <span className="text-red-500 text-xl" data-id="element-58">❌</span>
                <span className="text-gray-800" data-id="element-59">
                  Un cliente te pregunta "¿y ahora qué sigue?" (y no quiere
                  teoría 😅)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-60">
                <span className="text-red-500 text-xl" data-id="element-61">❌</span>
                <span className="text-gray-800" data-id="element-62">
                  Y el PJN… bueno, el PJN no perdona distracciones
                </span>
              </div>
            </div>
            <p className="text-lg text-gray-700 mt-6 font-semibold" data-id="element-63">
              No es que no sepas. Es que nadie te dio el paso a paso real.
            </p>
          </div>

          <div className="bg-black text-white rounded-xl shadow-lg p-8 mb-8" data-id="element-64">
            <h3 className="text-2xl md:text-3xl font-black mb-6 text-yellow-400 uppercase text-center" data-id="element-65">
              El problema que nadie dice en voz alta (pero todos viven)
            </h3>
            <p className="text-lg mb-6" data-id="element-66">
              En tu primer año, es normal que pase esto:
            </p>
            <div className="space-y-4" data-id="element-67">
              <div className="flex items-start gap-3" data-id="element-68">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-69" />
                <span data-id="element-70">Tenés conocimiento… pero no tenés sistema</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-71">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-72" />
                <span data-id="element-73">Te cuesta saber "qué va primero" y "qué no se toca"</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-74">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-75" />
                <span data-id="element-76">Perdés horas buscando modelos (y ninguno coincide)</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-77">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-78" />
                <span data-id="element-79">
                  Dudás con requisitos, adjuntos, formatos, presentación
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-80">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-81" />
                <span data-id="element-82">Te frena el miedo al error "de principiante"</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-83">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-84" />
                <span data-id="element-85">
                  Te agarran casos y sentís que estás corriendo atrás de todo
                </span>
              </div>
            </div>
            <p className="text-xl font-bold mt-8 text-red-400 text-center" data-id="element-86">
              Y lo peor: laburás mucho, avanzás poco, y vivís con la sensación
              de estar siempre atrás.
            </p>
          </div>

          {/* → scroll a oferta */}
          <div className="text-center" data-id="element-87">
            <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-10 py-5 rounded-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 uppercase text-center" data-id="element-88">
              Quiero Dejar de Improvisar → Ver Oferta
            </a>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="w-full bg-black text-white py-16 px-4" data-id="element-89">
        <div className="max-w-4xl mx-auto text-center" data-id="element-90">
          <div className="inline-block bg-green-500 text-white font-black text-lg px-6 py-2 rounded-full mb-6 uppercase" data-id="element-91">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-6 uppercase text-center" data-id="element-92">
            GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026 + 6 BONUS
          </h2>
          <p className="text-xl mb-12 text-gray-300 text-center" data-id="element-93">
            Un sistema práctico para que tus primeros pasos sean claros,
            ordenados y profesionales, válido para toda Argentina 🇦🇷
          </p>

          <div className="bg-gray-900 rounded-xl p-8 mb-12" data-id="element-94">
            <h3 className="text-2xl font-bold mb-6 text-yellow-400 uppercase text-center" data-id="element-95">
              Cómo se usa (en 3 pasos)
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-96">
              <div className="bg-black rounded-lg p-6 text-center" data-id="element-97">
                <div className="text-4xl font-black text-yellow-400 mb-4" data-id="element-98">
                  1
                </div>
                <p className="text-lg" data-id="element-99">Abrís la guía</p>
              </div>
              <div className="bg-black rounded-lg p-6 text-center" data-id="element-100">
                <div className="text-4xl font-black text-yellow-400 mb-4" data-id="element-101">
                  2
                </div>
                <p className="text-lg" data-id="element-102">Elegís el trámite / situación</p>
              </div>
              <div className="bg-black rounded-lg p-6 text-center" data-id="element-103">
                <div className="text-4xl font-black text-yellow-400 mb-4" data-id="element-104">
                  3
                </div>
                <p className="text-lg" data-id="element-105">
                  Aplicás el paso a paso + material listo
                </p>
              </div>
            </div>
            <p className="text-xl font-bold mt-8 text-yellow-400 text-center" data-id="element-106">
              Sin vueltas. Sin improvisar. Sin perder tiempo.
            </p>
          </div>

          {/* → scroll a oferta */}
          <a href="#compra" onClick={scrollToOffer} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center" data-id="element-107">
            🟩 VER OFERTA AHORA
          </a>
        </div>
      </section>

      {/* What's Included Section */}
      <section className="w-full bg-white py-8 px-4" data-id="element-108">
        <div className="max-w-5xl mx-auto text-center" data-id="element-109">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6 uppercase text-center" data-id="element-110">
            ¿Qué incluye exactamente?
          </h2>

          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl shadow-xl p-8 mb-8" data-id="element-111">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-112">
              <StarIcon className="h-8 w-8 text-yellow-500 fill-yellow-500" data-id="element-113" />
              <h3 className="text-2xl md:text-3xl font-black text-gray-900 uppercase text-center" data-id="element-114">
                Producto principal
              </h3>
            </div>
            <a href="#compra" onClick={scrollToOffer} className="block mb-4" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/gN2kG2xBBMWAFKYTTxmgEw/Guia_de_procuracion_juridica_Paso_a_paso.png" alt="Guía Paso a Paso de Procuración Jurídica 2026" className="w-full max-w-xl mx-auto h-auto rounded-lg shadow-lg hover:scale-105 transition-transform duration-300" style={{
              aspectRatio: '1/1',
              objectFit: 'cover'
            }} data-id="element-116" />
            </a>
            <h4 className="text-2xl font-bold text-gray-900 mb-3 text-center" data-id="element-117">
              GUÍA PASO A PASO DE PROCURACIÓN JURÍDICA 2026
            </h4>
            <p className="text-lg text-gray-700 mb-3 text-center" data-id="element-118">
              Pensada para noveles abogados que necesitan:
            </p>
            <ul className="space-y-3 text-gray-800 max-w-md mx-auto text-left" data-id="element-119">
              <li className="flex items-start gap-3" data-id="element-120">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-121" />
                <span data-id="element-122">Orden mental (qué va primero, qué va después)</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-123">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-124" />
                <span data-id="element-125">Ejecución (no "información para leer algún día")</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-126">
                <CheckIcon className="h-6 w-6 text-green-500 flex-shrink-0 mt-1" data-id="element-127" />
                <span data-id="element-128">Una ruta clara para actuar con criterio y rapidez</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="w-full bg-gray-50 pt-4 pb-10 px-4" data-id="element-129">
        <div className="max-w-6xl mx-auto" data-id="element-130">
          <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl p-6 mb-6 text-center" data-id="element-131">
            <h2 className="text-3xl md:text-5xl font-black text-black uppercase text-center" data-id="element-132">
              🎁 BONUS INCLUIDOS HOY
            </h2>
            <p className="text-xl font-bold text-black mt-2 text-center" data-id="element-133">
              (sin costo adicional)
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 text-center" data-id="element-134">
            <p className="text-2xl font-bold text-red-600 uppercase text-center" data-id="element-135">
              ⚡ Estos bonos son GRATIS por el día de hoy ⚡
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-136">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-137">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-138">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-139">
                  <img src="https://cdn.magicpatterns.com/uploads/dmZen66tPjYDX1sotCwXwK/Bonus_1.png" alt="Bonus 1" className="w-full h-full object-cover" data-id="element-140" />
                </div>
                <div className="p-6 text-center" data-id="element-141">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-142">
                    ✅ BONUS 1: Introducción – Escritos Judiciales Paso a Paso
                  </h3>
                  <p className="text-gray-700" data-id="element-143">
                    Para dejar de armar escritos "a ojo" y entender: estructura,
                    lógica, qué va / qué no va, errores típicos de principiante
                    que te hacen perder tiempo.
                  </p>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-144">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-145">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-146">
                  <img src="https://cdn.magicpatterns.com/uploads/vo6eXqb7q1Dns49oikMBZ8/Bonus_2.png" alt="Bonus 2" className="w-full h-full object-cover" data-id="element-147" />
                </div>
                <div className="p-6 text-center" data-id="element-148">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-149">
                    ✅ BONUS 2: Guía Completa: Cómo Subir un Escrito al Portal
                    del PJN
                  </h3>
                  <p className="text-gray-700" data-id="element-150">
                    Para que el PJN no te coma la cabeza: paso a paso claro,
                    checklist previo a subir, cómo evitar trabas comunes,
                    presentación sin pánico.
                  </p>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-151">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-152">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-153">
                  <img src="https://cdn.magicpatterns.com/uploads/xw4C8Bo7tFvuqQ8dBb9i9d/Bonus_3.png" alt="Bonus 3" className="w-full h-full object-cover" data-id="element-154" />
                </div>
                <div className="p-6 text-center" data-id="element-155">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-156">
                    ✅ BONUS 3: Guía Práctica de Honorarios Profesionales
                    (Argentina)
                  </h3>
                  <p className="text-gray-700" data-id="element-157">
                    Para que no te pase el clásico: "¿Cuánto cobro?" → silencio
                    incómodo. Acá tenés criterio para presupuestar y cobrar sin
                    regalarte.
                  </p>
                </div>
              </div>
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-158">
            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-159">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-160">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-161">
                  <img src="https://cdn.magicpatterns.com/uploads/r3X8EagC5xJm8b4HKhFQbT/Bonus_4.png" alt="Bonus 4" className="w-full h-full object-cover" data-id="element-162" />
                </div>
                <div className="p-6 text-center" data-id="element-163">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-164">
                    ✅ BONUS 4: Guía Práctica: Tu Primera Entrevista con
                    Clientes
                  </h3>
                  <p className="text-gray-700" data-id="element-165">
                    Para que la entrevista no sea un caos: qué preguntar, cómo
                    ordenar el caso, cómo transmitir seguridad sin humo, cómo
                    salir con próximos pasos claros.
                  </p>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-166">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-167">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-168">
                  <img src="https://cdn.magicpatterns.com/uploads/aP8hCyUAzELr5zghVNRPmQ/Bonus_5.png" alt="Bonus 5" className="w-full h-full object-cover" data-id="element-169" />
                </div>
                <div className="p-6 text-center" data-id="element-170">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-171">
                    ✅ BONUS 5: Pasos Previos al Ejercicio Profesional
                  </h3>
                  <p className="text-gray-700" data-id="element-172">
                    Checklist para empezar bien: orden básico, preparación
                    práctica, prevención de errores por apuro.
                  </p>
                </div>
              </div>
            </a>

            <a href="#compra" onClick={scrollToOffer} className="block" data-id="element-173">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 border-2 border-green-500" data-id="element-174">
                <div className="w-full" style={{
                aspectRatio: '1/1'
              }} data-id="element-175">
                  <img src="https://cdn.magicpatterns.com/uploads/m4unkkyeQbYhT7YdQ3UiF8/Bonus_6.png" alt="Bonus 6" className="w-full h-full object-cover" data-id="element-176" />
                </div>
                <div className="p-6 text-center" data-id="element-177">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center" data-id="element-178">
                    ✅ BONUS 6: GRUPO DE WHATSAPP (+400 colegas)
                  </h3>
                  <p className="text-gray-700" data-id="element-179">
                    Cuando aparece esa duda que te frena: entrás, preguntás,
                    destrabás y seguís.
                  </p>
                  <div className="mt-4 flex items-center justify-center gap-2 text-green-600 font-semibold" data-id="element-180">
                    <UsersIcon className="h-5 w-5" data-id="element-181" />
                    <span data-id="element-182">Comunidad activa</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Before/After Section */}
      <section className="w-full bg-white py-12 px-4" data-id="element-183">
        <div className="max-w-6xl mx-auto" data-id="element-184">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-8 text-center uppercase" data-id="element-185">
            ⚔️ Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-186">
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl shadow-lg p-8 border-2 border-red-300" data-id="element-187">
              <h3 className="text-2xl font-black text-red-700 mb-6 uppercase text-center" data-id="element-188">
                Antes (primer año modo supervivencia)
              </h3>
              <div className="space-y-4" data-id="element-189">
                <div className="flex items-start gap-3" data-id="element-190">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-191" />
                  <span className="text-gray-800" data-id="element-192">Dudas constantes</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-193">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-194" />
                  <span className="text-gray-800" data-id="element-195">
                    Horas perdidas buscando modelos
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-196">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-197" />
                  <span className="text-gray-800" data-id="element-198">
                    Miedo a errores "tontos"
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-199">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-200" />
                  <span className="text-gray-800" data-id="element-201">Honorarios a ojo</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-202">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-203" />
                  <span className="text-gray-800" data-id="element-204">
                    Entrevistas sin estructura
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-205">
                  <XIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-1" data-id="element-206" />
                  <span className="text-gray-800" data-id="element-207">
                    Sensación de "me falta algo"
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl shadow-lg p-8 border-2 border-green-500" data-id="element-208">
              <h3 className="text-2xl font-black text-green-700 mb-6 uppercase text-center" data-id="element-209">
                Después (primer año con sistema)
              </h3>
              <div className="space-y-4" data-id="element-210">
                <div className="flex items-start gap-3" data-id="element-211">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-212" />
                  <span className="text-gray-800" data-id="element-213">
                    Pasos claros y ordenados
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-214">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-215" />
                  <span className="text-gray-800" data-id="element-216">
                    Material listo para aplicar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-217">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-218" />
                  <span className="text-gray-800" data-id="element-219">
                    Más seguridad al presentar
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-220">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-221" />
                  <span className="text-gray-800" data-id="element-222">Menos tiempo perdido</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-223">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-224" />
                  <span className="text-gray-800" data-id="element-225">Honorarios con criterio</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-226">
                  <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" data-id="element-227" />
                  <span className="text-gray-800" data-id="element-228">
                    Entrevistas que terminan en "siguiente paso"
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Today Section */}
      <section className="w-full bg-black text-white py-16 px-4" data-id="element-229">
        <div className="max-w-4xl mx-auto text-center" data-id="element-230">
          <h2 className="text-3xl md:text-5xl font-black mb-12 uppercase text-center" data-id="element-231">
            🧾 Lo que recibís hoy
          </h2>
          <div className="bg-gray-900 rounded-xl p-8" data-id="element-232">
            <div className="space-y-4 text-left" data-id="element-233">
              <div className="flex items-start gap-3" data-id="element-234">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-235" />
                <span className="text-lg" data-id="element-236">
                  Guía Paso a Paso de Procuración Jurídica 2026
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-237">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-238" />
                <span className="text-lg" data-id="element-239">
                  Bonus 1: Escritos Judiciales Paso a Paso
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-240">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-241" />
                <span className="text-lg" data-id="element-242">
                  Bonus 2: Subida al PJN (fueros principales)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-243">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-244" />
                <span className="text-lg" data-id="element-245">
                  Bonus 3: Honorarios Profesionales (Argentina)
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-246">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-247" />
                <span className="text-lg" data-id="element-248">
                  Bonus 4: Primera Entrevista con Clientes
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-249">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-250" />
                <span className="text-lg" data-id="element-251">
                  Bonus 5: Pasos Previos al Ejercicio Profesional
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-252">
                <CheckIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-253" />
                <span className="text-lg" data-id="element-254">
                  Bonus 6: Acceso exclusivo al grupo WhatsApp con +400 colegas
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-255">
                <ZapIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-1" data-id="element-256" />
                <span className="text-lg font-bold" data-id="element-257">
                  Acceso inmediato + descarga digital + acceso de por vida
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section — CHECKOUT DIRECTO */}
      <section id="compra" className="w-full bg-white py-8 px-4" data-id="element-258">
        <div className="max-w-4xl mx-auto text-center" data-id="element-259">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 uppercase text-center" data-id="element-260">
            💸 Precio
          </h2>
          <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl shadow-2xl p-8 mb-6 border-4 border-yellow-400" data-id="element-261">
            <p className="text-2xl text-gray-600 mb-1 line-through text-center" data-id="element-262">
              Precio regular: ARS 84.990
            </p>
            <div className="mb-4 text-center" data-id="element-263">
              <p className="text-5xl md:text-7xl font-black text-red-600 mb-1 text-center" data-id="element-264">
                HOY SOLO:
              </p>
              <p className="text-6xl md:text-8xl font-black text-green-600 text-center" data-id="element-265">
                ARS 34.999
              </p>
            </div>
            <div className="flex justify-center mb-4" data-id="element-266">
              <div className="inline-block bg-green-500 text-white font-black text-2xl px-8 py-3 rounded-full" data-id="element-267">
                ✅ Ahorrás: ARS 49.991
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-3 mb-4 text-left max-w-2xl mx-auto" data-id="element-268">
              <div className="flex items-center gap-3" data-id="element-269">
                <CheckIcon className="h-6 w-6 text-green-600 flex-shrink-0" data-id="element-270" />
                <span className="text-gray-800 font-semibold" data-id="element-271">
                  En hasta 3 cuotas
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-272">
                <ZapIcon className="h-6 w-6 text-yellow-600 flex-shrink-0" data-id="element-273" />
                <span className="text-gray-800 font-semibold" data-id="element-274">
                  Acceso inmediato
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-275">
                <DownloadIcon className="h-6 w-6 text-blue-600 flex-shrink-0" data-id="element-276" />
                <span className="text-gray-800 font-semibold" data-id="element-277">
                  Descarga digital
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-278">
                <ClockIcon className="h-6 w-6 text-purple-600 flex-shrink-0" data-id="element-279" />
                <span className="text-gray-800 font-semibold" data-id="element-280">
                  Acceso de por vida
                </span>
              </div>
            </div>

            <p className="text-xl font-bold text-gray-800 mb-4 text-center" data-id="element-281">
              ✔ Válido para toda Argentina 🇦🇷
            </p>

            <div className="flex justify-center" data-id="element-282">
              <a href={PURCHASE_URL} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-xl md:text-2xl px-10 py-5 rounded-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center" data-id="element-283">
                🟩 SÍ, QUIERO ACCEDER AHORA
              </a>
            </div>
          </div>

          <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl p-6 inline-block shadow-lg" data-id="element-284">
            <div className="flex items-center justify-center gap-4 mb-3" data-id="element-285">
              <ShieldIcon className="h-10 w-10 text-black" data-id="element-286" />
              <h3 className="text-2xl font-black text-black uppercase text-center" data-id="element-287">
                Garantía sin riesgo
              </h3>
            </div>
            <p className="text-lg text-black font-bold text-center" data-id="element-288">
              ⭐ Probalo 7 días. Si no te sirve, pedís reembolso y listo. Sin
              vueltas. ⭐
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="w-full bg-gray-50 py-10 px-4" data-id="element-289">
        <div className="max-w-6xl mx-auto" data-id="element-290">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-12 text-center uppercase" data-id="element-291">
            ⭐ Lo que dicen otros noveles abogados
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-292">
            {[{
            name: 'Valentina Rodríguez',
            age: 25,
            city: 'Buenos Aires',
            text: '"Me ordenó la cabeza completamente. Dejé de tardar horas en cosas básicas y ahora presento escritos con confianza."'
          }, {
            name: 'Matías González',
            age: 27,
            city: 'Córdoba',
            text: '"El paso a paso del PJN me ahorró errores reales. Lo recomiendo a cualquier novel que esté empezando."'
          }, {
            name: 'Lucía Fernández',
            age: 26,
            city: 'Rosario',
            text: '"Por fin entendí cómo cobrar mis honorarios sin sentirme incómoda. Vale cada peso."'
          }, {
            name: 'Sebastián Torres',
            age: 28,
            city: 'Mendoza',
            text: '"La guía de la primera entrevista me cambió todo. Ahora salgo con próximos pasos claros siempre."'
          }, {
            name: 'Camila Martínez',
            age: 25,
            city: 'Tucumán',
            text: '"Dejé de improvisar. Tengo un sistema real para ejercer y eso me da una seguridad que antes no tenía."'
          }].map((t, i) => <div key={i} className="bg-white rounded-xl shadow-lg p-6" data-id="element-293">
                <div className="flex gap-1 mb-4 justify-center" data-id="element-294">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="h-5 w-5 text-yellow-400 fill-yellow-400" data-id="element-295" />)}
                </div>
                <p className="text-gray-700 mb-4 italic text-center" data-id="element-296">
                  {t.text}
                </p>
                <div className="border-t pt-4 text-center" data-id="element-297">
                  <p className="font-bold text-gray-900" data-id="element-298">{t.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-299">
                    {t.age} años — Abogado/a (1er año) — {t.city}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-white py-10 px-4" data-id="element-300">
        <div className="max-w-4xl mx-auto" data-id="element-301">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-12 text-center uppercase" data-id="element-302">
            ❓ Preguntas frecuentes
          </h2>
          <div className="space-y-4" data-id="element-303">
            {[{
            q: '¿Esto es para estudiantes?',
            a: 'No. Está pensado solo para noveles abogados en su primer año.'
          }, {
            q: '¿Es material digital?',
            a: 'Sí. Acceso y descarga inmediata.'
          }, {
            q: '¿Sirve en cualquier provincia?',
            a: 'Sí. Es válido para toda Argentina. (Y el bono del PJN aplica a los fueros principales.)'
          }, {
            q: '¿Necesito experiencia previa?',
            a: 'No. Es paso a paso, pensado para arrancar con estructura.'
          }, {
            q: '¿Esto reemplaza asesoramiento legal?',
            a: 'No. Es material educativo y de apoyo práctico. La estrategia jurídica siempre depende del caso.'
          }].map((faq, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-304">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-100 transition-colors" data-id="element-305">
                  <span className="text-lg font-bold text-gray-900" data-id="element-306">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-6 w-6 text-gray-600 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-307" />
                </button>
                {openFaq === index && <div className="px-6 pb-6" data-id="element-308">
                    <p className="text-gray-700" data-id="element-309">{faq.a}</p>
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="w-full bg-black text-white py-10 px-4" data-id="element-310">
        <div className="max-w-4xl mx-auto text-center" data-id="element-311">
          <h2 className="text-3xl md:text-5xl font-black mb-8 uppercase text-center" data-id="element-312">
            Tu primer año no tiene por qué ser "modo caos".
          </h2>
          <p className="text-xl md:text-2xl mb-4 text-center" data-id="element-313">
            No necesitás más PDFs sueltos.
          </p>
          <p className="text-xl md:text-2xl mb-12 text-center" data-id="element-314">
            Necesitás un sistema para ejercer con seguridad y velocidad desde
            ya.
          </p>
          {/* ÚLTIMO BOTÓN → CHECKOUT DIRECTO */}
          <a href={PURCHASE_URL} className="inline-block bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-2xl md:text-4xl px-16 py-8 rounded-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 animate-pulse-slow uppercase text-center" data-id="element-315">
            🟩 ACCEDÉ AHORA — ARS 34.999 (HOY)
          </a>
        </div>
      </section>
    </div>;
}